var $a61375bbb065e4f1$exports = {};
(function() {
    const task = getTaskID();
    if (task) {
        console.log(`Jira taskId: ${task}`);
        console.log(`URL: https://pixrig.atlassian.net/browse/${task}`);
        console.log('Hash commit: ', "25a1b7063cd5a2b04393dbae733ce06b8888da6f");
    }
    function getTaskID() {
        const commitMessage = undefined;
        if (commitMessage) {
            const taskID = commitMessage.match(/EN-\d+/);
            if (taskID) return taskID[0];
        }
        return null;
    }
})();


//# sourceMappingURL=storibox.72212869.js.map
